// extracted by mini-css-extract-plugin
export default {"container":"ViewDetailsContainer_container__Ay+yE"};